import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import type { IIconsButtonProps } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";

import { withSWReactIconFillColor } from "app/pages/sales-intelligence/common-components/styles";

const ICON_XY = 24;

export const StyledIconButton = styled(IconButton)<IIconsButtonProps>`
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "default")};

    ${SWReactIcons} svg {
        width: ${ICON_XY}px;
        height: ${ICON_XY}px;
    }

    &,
    &:hover {
        ${({ isDisabled }) => !isDisabled && withSWReactIconFillColor(colorsPalettes.blue[400])}
    }
`;
